__turbopack_context__.v({
  "active": "WhyBusinessesChoose-module__mKGMdW__active",
  "card": "WhyBusinessesChoose-module__mKGMdW__card",
  "cardBody": "WhyBusinessesChoose-module__mKGMdW__cardBody",
  "cardTitle": "WhyBusinessesChoose-module__mKGMdW__cardTitle",
  "cardsWrap": "WhyBusinessesChoose-module__mKGMdW__cardsWrap",
  "chip": "WhyBusinessesChoose-module__mKGMdW__chip",
  "chip0": "WhyBusinessesChoose-module__mKGMdW__chip0",
  "chip1": "WhyBusinessesChoose-module__mKGMdW__chip1",
  "chip2": "WhyBusinessesChoose-module__mKGMdW__chip2",
  "chip3": "WhyBusinessesChoose-module__mKGMdW__chip3",
  "eyebrow": "WhyBusinessesChoose-module__mKGMdW__eyebrow",
  "flowX": "WhyBusinessesChoose-module__mKGMdW__flowX",
  "flowY": "WhyBusinessesChoose-module__mKGMdW__flowY",
  "head": "WhyBusinessesChoose-module__mKGMdW__head",
  "hero": "WhyBusinessesChoose-module__mKGMdW__hero",
  "heroBg": "WhyBusinessesChoose-module__mKGMdW__heroBg",
  "hub": "WhyBusinessesChoose-module__mKGMdW__hub",
  "hubInner": "WhyBusinessesChoose-module__mKGMdW__hubInner",
  "iconBadge": "WhyBusinessesChoose-module__mKGMdW__iconBadge",
  "metric": "WhyBusinessesChoose-module__mKGMdW__metric",
  "metricIcon": "WhyBusinessesChoose-module__mKGMdW__metricIcon",
  "metricLabel": "WhyBusinessesChoose-module__mKGMdW__metricLabel",
  "metricSuffix": "WhyBusinessesChoose-module__mKGMdW__metricSuffix",
  "metricValue": "WhyBusinessesChoose-module__mKGMdW__metricValue",
  "metricsRow": "WhyBusinessesChoose-module__mKGMdW__metricsRow",
  "modal": "WhyBusinessesChoose-module__mKGMdW__modal",
  "modalBackdrop": "WhyBusinessesChoose-module__mKGMdW__modalBackdrop",
  "modalBody": "WhyBusinessesChoose-module__mKGMdW__modalBody",
  "modalClose": "WhyBusinessesChoose-module__mKGMdW__modalClose",
  "modalHeader": "WhyBusinessesChoose-module__mKGMdW__modalHeader",
  "modalStat": "WhyBusinessesChoose-module__mKGMdW__modalStat",
  "modalStats": "WhyBusinessesChoose-module__mKGMdW__modalStats",
  "node": "WhyBusinessesChoose-module__mKGMdW__node",
  "orbit": "WhyBusinessesChoose-module__mKGMdW__orbit",
  "radial": "WhyBusinessesChoose-module__mKGMdW__radial",
  "radialSvg": "WhyBusinessesChoose-module__mKGMdW__radialSvg",
  "section": "WhyBusinessesChoose-module__mKGMdW__section",
  "spin": "WhyBusinessesChoose-module__mKGMdW__spin",
  "stacked": "WhyBusinessesChoose-module__mKGMdW__stacked",
  "subtitle": "WhyBusinessesChoose-module__mKGMdW__subtitle",
  "title": "WhyBusinessesChoose-module__mKGMdW__title",
  "track": "WhyBusinessesChoose-module__mKGMdW__track",
});
